import { UNIT } from 'src/settings/settings';
import { Fund } from './components/Exchange/types';
import { SellFund } from './redux/modules/sellTransaction/types';

export type ArgeementIDtuple = [Fund['agreementID'], Fund['agreementID']];

export interface Withholding {
  readonly applied: boolean;
  readonly disabled?: boolean;
  readonly dollars?: number;
  readonly isEstimate?: boolean;
  readonly percent: number;
}

export interface WithholdingObject {
  readonly agreementID: Fund['agreementID'];
  readonly federalWithholdingApplied: boolean;
  readonly federalWithholdingPercent: number;
}
export interface UnitSelection {
  readonly grossAmount: number;
  readonly selectedDays: ItemSelection[];
  readonly selectedMonths: ItemSelection[];
  readonly grossUnit: UNIT;
  readonly selected?: boolean;
  readonly closeout?: boolean;
}
export interface Bank {
  accountNumber: string;
  bankAccountType: string;
  bankAgreementID: string;
  bankAgreementSerivceFeatures?;
  bankAwaitingVerification: boolean;
  bankStatus?;
  bankVerificationDate?;
  corruptBankData?;
  hasRedemptionHold?(hasRedemptionHold?): boolean;
  name: string;
  externallyVerifiedBank: boolean;
  registrationLines?;
  routingNumber: Bank | undefined;
  sameDayBank: boolean;
  verificationStatus: string;
}

export interface FoundFeature {
  serviceID?: number;
}
export interface FundLock {
  fundLocked: boolean;
  foundFeatures: FoundFeature[];
  missingRequiredFeatures: FoundFeature[];
}
export interface UserFund extends Fund {
  correspondingFund?;
  fundLock?: FundLock;
  hasEarlyWithdrawalPenalty?: boolean;
  startDate?;
  transferDays?: ItemSelection[];
  transferMonths?: ItemSelection[];
}

export interface SystematicSellFund
  extends Omit<SellFund, 'transferMonths' | 'transferDays'> {
  transferDays: number[];
  transferMonths: number[];
  grossUnit: UNIT;
}

export type FundSummary = Pick<
  Fund,
  | 'agreementID'
  | 'agreementNumber'
  | 'agreementType'
  | 'ticker'
  | 'displayClassification'
  | 'formattedEntityNames'
  | 'fundName'
  | 'grossAmountDollars'
>;

export interface ItemSelection {
  label: string;
  value: number;
}

export enum PopUpPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}
export type Predicate = <T = unknown>(args?: T) => boolean;
export type ModalName = string;
export type valueof<T> = T[keyof T];
declare global {
  interface Window {
    trpsearch?: {
      rePhraseRules: Record<string, unknown>;
    };
  }
}
